

import { Injectable } from '@angular/core';
import { QueueStatus } from './mobile-queue-bean';
import { TranslateUtilityService } from 'src/app/system/utility/translation-utility.service';

@Injectable({
    providedIn: 'root'
})
export class MobileQueueUtilityService {

    private titleMap = new Map<QueueStatus, string>();
    private messageMap = new Map<QueueStatus, string>();

    constructor(private translate: TranslateUtilityService) {
        this.titleMap.set(QueueStatus.PENDING, 'MOBILE_QUEUE.LABEL_PENDING_TITLE');
        this.titleMap.set(QueueStatus.ROUTED, 'MOBILE_QUEUE.LABEL_ROUTED_TITLE');
        this.titleMap.set(QueueStatus.CUSTOMER_HERE, 'MOBILE_QUEUE.CUSTOMER_HERE_TITLE');
        this.titleMap.set(QueueStatus.ABANDONED, 'MOBILE_QUEUE.ABANDONED_TITLE');
        this.titleMap.set(QueueStatus.CLOSED, 'MOBILE_QUEUE.CLOSED_TITLE');
        this.titleMap.set(QueueStatus.EXPIRED, 'MOBILE_QUEUE.EXPIRED_TITLE');

        // Only these 3 status have default message 
        this.messageMap.set(QueueStatus.ABANDONED, 'MOBILE_QUEUE.ABANDONED_MESSAGE');
        this.messageMap.set(QueueStatus.CLOSED, 'MOBILE_QUEUE.CLOSED_MESSAGE');
        this.messageMap.set(QueueStatus.EXPIRED, 'MOBILE_QUEUE.EXPIRED_MESSAGE');

    }

    public getTitle(status: QueueStatus): string {
        return this.titleMap.get(status)!;
    }

    public getDefaultMessage(status: QueueStatus): string {
        return this.messageMap.get(status)!;
    }

}